import React, { useState, useEffect } from 'react'
import StorefrontTitle from "../shared/storefront-title.component";
import Translations from '../../services/translation.service';
import Settings from '../../services/settings.service';
import SpinnerTimeLoader from '../shared/timeLoading';
import PhoneCalling from "../../assets/img/PhoneCalling.svg";
// import PhoneTick from "../../assets/img/PhoneTick.svg";
// import PhoneTickX from "../../assets/img/PhoneWrong.svg";
import SharedPhone from "../shared/sharedFields/phone";
import BillPaymentService from "../../services/bill-payment.service";
import Helpers from '../../helpers/shared.helper';
import Storage from '../../services/storage.service';
import FirebaseAnalytics from '../../services/analytics.service';

const subscriptions = [];
const BillPaymentForm = ({ props }) => {
    const [translationKeys, setTranslationsKeys] = useState(
        Translations.keys ? Translations.keys : {}
    );
    const [formValues, setFormValues] = useState({
        submitLoader: false,
        nextStep: false,
        phone: {
            phoneCode: Settings?.country,
            value: "",
            touched: false,
            valid: false,
            validation: {
                required: true,
                phoneNumber: true,
                minLength: true,
                minLengthValue: 7,
                maxLength: true,
                maxLengthValue: 15,
            }
        },
        maskedContactNumber: null,
        contactNumber: null
    });

    useEffect(() => {
        const firebase_event_params = {
            event_category: 'bills',
            event_screen: 'bill_landing',
            interaction_type: 'view',
            event_label: 'screen'
        }
        FirebaseAnalytics.commonFunction(firebase_event_params);
        // const phoneMaxLength = Helpers.getPOValue("top_up_number_length", 10);
        const phoneMaxLength = Helpers.getPOValue("hbb_number_length", 15);
        setFormValues(prevState => ({
            ...prevState,
            phone: {
                ...prevState.phone,
                validation: {
                    ...prevState.phone.validation,
                    maxLengthValue: phoneMaxLength
                }
            },
            nextStep: false,
        }));
    }, [])

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        subscriptions.push(
        Translations.getKeysObsrv().subscribe((data) => {
            setTranslationsKeys(data);
        })
        );

        return () => {
        if (subscriptions && subscriptions?.length) {
            for (let subscription of subscriptions) {
            subscription.unsubscribe();
            }
        }
        };
    }, []);

    const updateContactInput = (phoneObj) => {
        setFormValues(prevState => ({
            ...prevState,
            phone: {
                ...prevState.phone,
                value: phoneObj.value,
            },
            nextStep: false,
        }));
    }

    const updateContactField = (phoneObj) => {
        Storage.clear("genericOTPError");
        setFormValues(prevState => ({
            ...prevState,
            phone: {
                ...prevState.phone,
                value: phoneObj.value,
                valid: phoneObj.valid,
                touched: phoneObj.touched,
                error: phoneObj.error
            },
        }));
        if(phoneObj.valid && phoneObj.touched) {
            setFormValues(prevState => ({
                ...prevState,
                submitLoader: true,
            }));
            let countryCode = Helpers.getCountryCodePO() || "";
            let data = {
                number: phoneObj?.value?.length === 15 ? phoneObj?.value : `${countryCode}${phoneObj?.value?.replace(/^0+/, '')}`,
                process: "bill_payment"
            }
            Storage.set("genericOTPError", true, true);
            BillPaymentService.requestOTP(data)
            .then(response => {
                Storage.set("genericOTPError", true, true);
                if(response) {
                    setFormValues(prevState => ({
                        ...prevState,
                        nextStep: true,
                        submitLoader: false,
                        maskedContactNumber: response?.data?.MaskContactNumber,
                        contactNumber: response?.data?.ContactNumber,
                        isHBB: response?.data?.IsHBB
                    }));
                    if(response?.data?.IsHBB) {
                        Storage.set("isHBB", response?.data?.IsHBB, true);
                    } else {
                        Storage.clear("isHBB");
                    }
                } else {
                    Storage.clear("isHBB");
                    setFormValues(prevState => ({
                        ...prevState,
                        nextStep: false,
                        submitLoader: false,                    
                        phone: {
                            ...prevState.phone,
                            valid: false,
                            error: "failed"
                        },
                    }));
                }
            })
            .catch(error => {
                Storage.clear("isHBB");
                setFormValues(prevState => ({
                    ...prevState,
                    nextStep: false,
                    submitLoader: false,                    
                    phone: {
                        ...prevState.phone,
                        valid: false,
                        error: error?.response?.data?.code
                    },
                }));
            });
        }
    }

    const moveToOTPScreen = () => {
        const firebase_event_params = {
            event_category: 'bills',
            event_screen: 'bill_landing',
            interaction_type: 'click',
            event_label: 'next',
            is_valid_numer: formValues?.phone?.valid ?? ""
        }
        FirebaseAnalytics.commonFunction(firebase_event_params);
        props.history.push({
            pathname: '/bill-payment/otp',
            state: { formValues: formValues }
        });
    }

    const convertError = (error) => {
        let errorCode = Math.abs(error);
        const firebase_event_params = {
            event_category: 'bills',
            event_screen: 'bill_landing',
            interaction_type: 'view',
            event_label: 'error',
            error_code:  errorCode || ""
        }
        FirebaseAnalytics.commonFunction(firebase_event_params);
        return errorCode ? `stm_bill_payment_phone_error_${errorCode}` : "stm_bill_payment_phone_error_general";
    }

    return (
        <>
            <div className="generic-form-container generic-bill-payment-form-container">
                <StorefrontTitle
                    title={translationKeys["stm_bill_payment_heading"]}
                    desc={translationKeys["stm_bill_payment_desc_hbb_postpaid"]}
                />
                <div className="field-section">
                    <div className="field-container">
                        <label>{translationKeys["stm_bill_payment_enter_number_hbb_postpaid"]}</label>
                        <div className="phone-field-with-tick">
                            <SharedPhone 
                                name="phone"
                                id="phone"
                                classname="storefront-phone-field tickIcon phoneIcon"
                                phone={formValues?.phone}
                                updateContactField={updateContactField}
                                updateContactInput={(e) => updateContactInput(e)}
                                placeholder={translationKeys["stm_bill_payment_phone_placeholder_hbb"]}
                                HBB={true}
                            />
                            <img src={PhoneCalling} className="imgLeft" alt=""/>
                            {/* {formValues.phone.touched && <img className="imgRight" src={formValues.phone.valid ? PhoneTick : PhoneTickX} alt=""/>} */}
                        </div>
                        {formValues.phone.error && !formValues.phone.valid ? <span className="error-msg">{translationKeys[convertError(formValues.phone.error)]}</span> : ""}
                    </div>

                    {formValues.submitLoader ?
                        <SpinnerTimeLoader /> 
                        :
                        <button
                            className={"common-button"}
                            disabled={!formValues.phone.valid && !formValues.nextStep}
                            onClick={() => {
                                moveToOTPScreen()
                            }}
                        >
                            {translationKeys["stm_bill_payment_next"] || "Next"} 
                        </button>
                    }
                </div>
            </div>
        </>
    );
};

export default BillPaymentForm;